import { Injectable } from '@angular/core';
import { SynchronizationsService } from '@proxy/services';
import { firstValueFrom } from 'rxjs';
import { SyncConsts } from '../../AppConsts';
import { LocalDb } from '../local-db';
import { LocalDbConsts } from '../local-db-consts';
import { ActivitySync } from '../objects/activity-sync';

@Injectable({ providedIn: 'root' })
export class ActivityRepository {
  constructor(
    private readonly _db: LocalDb,
    private readonly _syncService: SynchronizationsService
  ) {}

  async refreshActivities(): Promise<void> {
    const table = this._db.activities;

    let skip = 0;
    let total = 0;

    let activities: ActivitySync[] = [];

    do {
      const result = await firstValueFrom(
        this._syncService.getActivities({
          skipCount: skip,
          maxResultCount: SyncConsts.PageSize,
        })
      );

      total = result.pagedResult.totalCount;

      activities = activities.concat(
        result.pagedResult.items.map(dto => ({
          id: dto.id,
          name: dto.name ?? '',
        }))
      );

      skip += SyncConsts.PageSize;
    } while (skip < total);

    await this._db.transaction(LocalDbConsts.localDbReadWriteTransaction, table, async () => {
      await table.clear();
      await table.bulkAdd(activities);
    });
  }

  async getAll(): Promise<ActivitySync[]> {
    return await this._db.activities.toArray();
  }

  getById(id: number): Promise<ActivitySync> {
    return this._db.activities.get(id);
  }
}
